import mainPage from "./components/MainPage"
import adminPage from "./components/Admin"

export default [
    {path: '/', component: mainPage},
    {path: '/admin', component: adminPage},
]